import {useI18next, useTranslation} from "gatsby-plugin-react-i18next";
import getPricingUrl from "../../page-components-new/home/getPricingUrl";

export const INTEGRATIONS = [
    {to: "/integrations/wordpress/", name: "WordPress"},
    {to: "/integrations/webflow/", name: "Webflow"},
    {to: "/integrations/freshdesk/", name: "Freshdesk"},
    {to: "/ecommerce/shopify/", name: "Shopify"},
    {to: "/ecommerce/woocommerce/", name: "WooCommerce"},
    {to: "/ecommerce/shoper/", name: "Shoper"},
    {to: "/ecommerce/prestashop/", name: "PrestaShop"},
    {to: "/ecommerce/wix/", name: "Wix"},
    {to: "/ecommerce/baselinker/", name: "BaseLinker"},
    {to: "/ecommerce/cscart/", name: "CS-Cart"},
    {to: "/ecommerce/abicart/", name: "Abicart"},
];

export const useNavItems = () => {
    const {t} = useTranslation();
    const {language} = useI18next();

    return {
        primary: [
            {to: "/industry/ecommerce/", label: t("For online stores")},
            {to: "/industry/hospitality/", label: t("For hotels")},
            {to: "/features/", label: t("Features")},
            {
                to: getPricingUrl(language),
                label: t("Pricing"),
                children: [
                    {to: "/pricing/", label: t("General"), note: t("Any business")},
                    {to: "/pricing/ecommerce/", label: t("E-commerce"), note: t("Online stores")},
                ],
            },
        ],
        resources: [
            {
                title: t("Learn"),
                items: [
                    {to: "/help/", label: t("Help Center")},
                    {to: "/blog/", label: t("Blog")},
                    {to: "/press/", label: t("Press & Media")},
                    {to: "/contact/", label: t("Contact")},
                ],
            },
            {
                title: t("Live demos"),
                items: [
                    {to: "/example/ecommerce/", label: t("Live demo: online store")},
                    {to: "/example/booking/", label: t("Live demo: hotel booking")},
                    {to: "/example/real-estate/", label: t("Live demo: real estate")},
                ],
                sections: [
                    {
                        title: t("Case studies"),
                        items: [
                            {to: "/usecase/olimplabs/", label: "Olimp Labs", note: t("E-commerce")},
                            {to: "/usecase/bmh/", label: "Black Mountain Honey", note: t("E-commerce")},
                            {to: "/usecase/umili/", label: "Umili Resorts", note: t("Hotels")},
                            {to: "/usecase/inmusic/", label: "inMusic", note: t("Music technology")},
                            {to: "/usecase/wieliczka/", label: t("Wieliczka Salt Mine"), note: t("Museums")},
                        ],
                    },
                ],
            },
            {
                title: t("Partner"),
                items: [
                    {to: "/agencypackage/", label: t("Agency program")},
                    {to: "/affiliates/", label: t("Affiliate program")},
                ],
                sections: [
                    {
                        title: t("More industries"),
                        items: [
                            {to: "/industry/museums/", label: t("Museums & travel guides")},
                            {to: "/industry/real-estate/", label: t("Real estate")},
                        ],
                    },
                    {
                        title: t("Compare"),
                        items: [
                            {to: "/comparator/", label: t("Compare with other chatbots")},
                        ],
                    },
                ],
            },
        ],
        integrations: INTEGRATIONS.map((i) => ({to: i.to, label: t("AI chatbot for {{name}}", {name: i.name})})),
        signIn: `https://app.chatlab.com/#/login?lang=${language}`,
        signUp: `https://app.chatlab.com/#/signup?lang=${language}`,
    };
};
